import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tag, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { money } from './format';

/**
 * Late-payment interest of a return: „—" when the principal was paid by the
 * due date; red when it is owed (an estimate „~X" unless typed from the tax
 * portal); green when paid under the return's BOP above its amount.
 */
export default function InterestTag({ value }) {
  const { t } = useTranslation('taxReturns');
  if (!value) return <span className="opacity-60">—</span>;
  const amount = `${value.estimated ? '~' : ''}${money(value.amount)}`;
  const tip = value.estimated ? t('interest.estimateTooltip') : value.manual ? t('interest.manualTooltip') : null;
  return (
    <Tooltip title={tip}>
      <Tag color={value.state === 'paid' ? 'green' : 'red'} icon={value.manual ? <EditOutlined /> : null}>
        {t(`interest.${value.state}`)} · {amount}
      </Tag>
    </Tooltip>
  );
}
